const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  ADMIN: '/admin',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    icp: {
      signIn: `${ROOTS.AUTH}/icp/sign-in`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    home: `${ROOTS.DASHBOARD}/home`,

    mentoring: `${ROOTS.DASHBOARD}/mentoring`,
    profile: `${ROOTS.DASHBOARD}/profile`,
    invites: `${ROOTS.DASHBOARD}/invites`,
    integration: `${ROOTS.DASHBOARD}/integration`,

    event: {
      root: `${ROOTS.DASHBOARD}/event`,
      new: `${ROOTS.DASHBOARD}/event/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/event/${id}/edit`,
    },

    community: {
      root: `${ROOTS.DASHBOARD}/community`,
      new: `${ROOTS.DASHBOARD}/community/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/community/${id}/edit`,
      members: (id: string) => `${ROOTS.DASHBOARD}/community/${id}/members`,
      invite: (id: string) => `${ROOTS.DASHBOARD}/community/${id}/invite`,
      memberedit: (id: string) => `${ROOTS.DASHBOARD}/community/memberedit/${id}`,
    },

    token: {
      root: `${ROOTS.DASHBOARD}/token`,
      new: `${ROOTS.DASHBOARD}/token/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/token/${id}/edit`,
    },

    rewardprogram: {
      root: `${ROOTS.DASHBOARD}/rewardprogram`,
      new: `${ROOTS.DASHBOARD}/rewardprogram/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/rewardprogram/${id}/edit`,
    },
  },
  admin: {
    root: ROOTS.ADMIN,
    repostatus: `${ROOTS.ADMIN}/repostatus`,
    profiles: `${ROOTS.ADMIN}/profiles`,
    configuration: `${ROOTS.ADMIN}/configuration`,
    backup: `${ROOTS.ADMIN}/backup`,
  },
};
